import setCookieOnClick from './set-cookie-on-click';

export default setCookieOnClick;
